import { render, staticRenderFns } from "./DownloadOmProtectPdf.vue?vue&type=template&id=1bd396a8"
import script from "./DownloadOmProtectPdf.vue?vue&type=script&lang=js"
export * from "./DownloadOmProtectPdf.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports